__turbopack_context__.v({
  "host": "DevFooterPortalHost-module-scss-module__9dtsHa__host",
});
